// extracted by mini-css-extract-plugin
module.exports = {"buttons":"_902a308","button":"_f7de35d"};